export default {
    //处理卡券方法
    loadData(tempData: any) {
        let wxcardItems: any = [];
        wxcardItems.push({
            type: "htmlpanel", // A HTML panel component
            html:
                "<div  width='100%'   class='csstable'><div  class='csstabletr'><span class='csstabletrspan span0'>&nbsp;</span><span class='csstabletrspan span1'>卡券类型</span><span class='csstabletrspan span2'>卡券名称</span><span class='csstabletrspan span3'><span>卡券有效期</span></span><span class='csstabletrspan span4'>库存</span><span class='csstabletrspan span5'>微信价(元)</span><span class='csstabletrspan span6'><span>卡券状态</span></span><div></div>"
        });
        if (!tempData || tempData.length == 0) {
            wxcardItems.push({
                type: "htmlpanel", // A HTML panel component
                html: "<div style='text-align: center;padding:90px 0'>暂无卡券</div>"
            });
        } else {
            //console.log(tempData);
            tempData.forEach((e: any) => {
                //console.log(e);
                if (e.errcode == 0) {
                    var temp = e.card;
                    //折扣券
                    if (temp.card_type == "DISCOUNT") {
                        var baseInfo = temp.discount.base_info;
                        wxcardItems.push({
                            type: "checkbox",
                            name: this.CardVal(baseInfo,temp),
                            label:
                                "<span class='csstabletrspan span1'>折扣券</span><span class='csstabletrspan span2'>" +
                                baseInfo.title +
                                "</span><span class='csstabletrspan span3'>" +
                                this.cardDataTimeFormat(baseInfo.date_info) +
                                "</span><span class='csstabletrspan span4'>" +
                                baseInfo.sku.quantity +
                                "</span><span class='csstabletrspan span5'>--</span><span class='csstabletrspan span6'>" +
                                this.CardStatus(baseInfo.status) +
                                "</span>"
                        });
                        // console.log(baseInfo);             
                    }
                    //代金券
                    if (temp.card_type == "CASH") {
                        var baseInfo = temp.cash.base_info;
                        wxcardItems.push({
                            type: "checkbox",
                            name: this.CardVal(baseInfo,temp),
                            label:
                                "<span class='csstabletrspan span1'>代金券</span><span class='csstabletrspan span2'>" +
                                baseInfo.title +
                                "</span><span class='csstabletrspan span3'>" +
                                this.cardDataTimeFormat(baseInfo.date_info) +
                                "</span><span class='csstabletrspan span4'>" +
                                baseInfo.sku.quantity +
                                "</span><span class='csstabletrspan span5'>--</span><span class='csstabletrspan span6'>" +
                                this.CardStatus(baseInfo.status) +
                                "</span>"
                        });
                    }
                    //兑换券
                    if (temp.card_type == "GIFT") {
                        var baseInfo = temp.gift.base_info;
                        wxcardItems.push({
                            type: "checkbox",
                            name: this.CardVal(baseInfo,temp),
                            label:
                                "<span class='csstabletrspan span1'>兑换券</span><span class='csstabletrspan span2'>" +
                                baseInfo.title +
                                "</span><span class='csstabletrspan span3'>" +
                                this.cardDataTimeFormat(baseInfo.date_info) +
                                "</span><span class='csstabletrspan span4'>" +
                                baseInfo.sku.quantity +
                                "</span><span class='csstabletrspan span5'>--</span><span class='csstabletrspan span6'>" +
                                this.CardStatus(baseInfo.status) +
                                "</span>"
                        });
                    }
                    //团购券
                    if (temp.card_type == "GROUPON") {
                        var baseInfo = temp.groupon.base_info;
                        wxcardItems.push({
                            type: "checkbox",
                            name: this.CardVal(baseInfo,temp),
                            label:
                                "<span class='csstabletrspan span1'>团购券</span><span class='csstabletrspan span2'>" +
                                baseInfo.title +
                                "</span><span class='csstabletrspan span3'>" +
                                this.cardDataTimeFormat(baseInfo.date_info) +
                                "</span><span class='csstabletrspan span4'>" +
                                baseInfo.sku.quantity +
                                "</span><span class='csstabletrspan span5'>--</span><span class='csstabletrspan span6'>" +
                                this.CardStatus(baseInfo.status) +
                                "</span>"
                        });
                    }
                    //优惠券
                    if (temp.card_type == "GENERAL_COUPON") {
                        var baseInfo = temp.general_coupon.base_info;
                        wxcardItems.push({
                            type: "checkbox",
                            name: this.CardVal(baseInfo,temp),
                            label:
                                "<span class='csstabletrspan span1'>优惠券</span><span class='csstabletrspan span2'>" +
                                baseInfo.title +
                                "</span><span class='csstabletrspan span3'>" +
                                this.cardDataTimeFormat(baseInfo.date_info) +
                                "</span><span class='csstabletrspan span4'>" +
                                baseInfo.sku.quantity +
                                "</span><span class='csstabletrspan span5'>--</span><span class='csstabletrspan span6'>" +
                                this.CardStatus(baseInfo.status) +
                                "</span>"
                        });
                    }
                    //会员卡：MEMBER_CARD;
                    if (temp.card_type == "MEMBER_CARD") {
                        var baseInfo = temp.member_card.base_info;
                        wxcardItems.push({
                            type: "checkbox",
                            name: this.CardVal(baseInfo,temp),
                            label:
                                "<span class='csstabletrspan span1'>会员卡</span><span class='csstabletrspan span2'>" +
                                baseInfo.title +
                                "</span><span class='csstabletrspan span3'>" +
                                this.cardDataTimeFormat(baseInfo.date_info) +
                                "</span><span class='csstabletrspan span4'>--</span><span class='csstabletrspan span5'>--</span><span class='csstabletrspan span6'>" +
                                this.CardStatus(baseInfo.status) +
                                "</span>"
                        });
                        //console.log(baseInfo);            
                    }
                    // 景点门票：SCENIC_TICKET ； 电影票：MOVIE_TICKET； 飞机票：BOARDING_PASS； 会议门票：MEETING_TICKET； 汽车票：BUS_TICKET;
                }
            });
        }
        //wxCardHtml = wxCardHtml + "</tbody></table>只能投放普通券";
        wxcardItems.push(
            {
              type: "htmlpanel", // component type
              html: "<div style='font-size:14px'>注意：因微信有防盗链限制可能会出现无法显示LOGO，但发布后可以正常显示！</div>"

            },
            {
                type: "button", // component type
                text: "获取最新卡券信息",
                primary: true,
                name: "wxCard-button"
                // disabled: true,
                //borderless: false
            }
        );
        return wxcardItems;
    },
    //卡券有效时间格式化
    cardDataTimeFormat(dateinfo: any) {
        if (dateinfo.fixed_term != 0) {
            if (dateinfo.fixed_begin_term == 0) {
                return "领取后当天生效" + dateinfo.fixed_term + "天有效";
            } else {
                return (
                    "领取后" +
                    dateinfo.fixed_begin_term +
                    "天生效" +
                    dateinfo.fixed_term +
                    "天有效"
                );
            }
        }
        if (dateinfo.begin_timestamp != 0) {
            return (
                this.formatDate(dateinfo.begin_timestamp * 1000) +
                "至" +
                this.formatDate(dateinfo.end_timestamp * 1000)
            );
        }
        return "&nbsp;";
    },
    //卡券状态格式化 “CARD_STATUS_NOT_VERIFY”,待审核 ； “CARD_STATUS_VERIFY_FAIL”,审核失败； “CARD_STATUS_VERIFY_OK”，通过审核； “CARD_STATUS_DELETE”，卡券被商户删除； “CARD_STATUS_DISPATCH”，在公众平台投放过的卡券 ；
    CardStatus(val: any) {
        switch (val) {
            case "CARD_STATUS_VERIFY_OK":
                return "待投放";
            case "CARD_STATUS_DISPATCH":
                return "投放过";
        }
    },
    //选择卡券内容
    CardVal(baseInfo: any,info:any) {
        let val =
            "logo_url|$|" +
            encodeURIComponent(baseInfo.logo_url) +
            "|$$|brand_name|$|" +
            encodeURIComponent(baseInfo.brand_name) +
            "|$$|title|$|" +
            encodeURIComponent(baseInfo.title) +
            "|$$|color|$|" +
            encodeURIComponent(baseInfo.color) +
            "|$$|cardid|$|" +
            baseInfo.id+
            "|$$|card_type|$|" +info.card_type;
        return val;
    },
    //时间戳转时间
    formatDate(value: any) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        let MMstr = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        let dstr = d < 10 ? "0" + d : d;
        let h = date.getHours();
        let hstr = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        let mstr = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        let sstr = s < 10 ? "0" + s : s;
        //return y + "-" + MMstr + "-" + dstr + " " + hstr + ":" + mstr + ":" + sstr;
        return y + "-" + MMstr + "-" + dstr;
    }
  
}
